import { Component, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'guidance-corp',
  templateUrl: './guidance-corp.component.html',
  styleUrls: ['./guidance-corp.component.scss'],
})
export class GuidanceCorpComponent implements OnInit {
public companyName = '';
public companyName1 ='の皆様';
public promotion;
public cnt = 100;

  constructor(
    private renderer: Renderer2,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService:Title,
  ) {
    this.titleService.setTitle("JOYFIT 企業契約企業負担");
  }

 slice(data){
  var list = [];
  var k = data - 1;
    for (var i = 1, j = 1; i <= this.companyName.length; i++, j++) {
      i = i + k;
      j = j + k;
      list.push(this.companyName.substring(j - data, i));
    }
  return list;
 }
  
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params == null || params == undefined) {
        this.router.navigate(['/company-register']);
      }
      this.companyName = params['company_name'] + this.companyName1;
      this.promotion = params['promotion'];
    });
    if(this.companyName != undefined) {
      console.log(this.companyName);
      var fontsize = 40;
      var substrings = this.slice(this.companyName.length);
      const canvas = <HTMLCanvasElement> document.getElementById("canvas");
      const ctx = canvas.getContext("2d");
      canvas.height = 200;
      canvas.width = 1200;

      const x = canvas.width / 2;
      var y = canvas.height;
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x, canvas.height);
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.textAlign = "center";
      ctx.fillStyle = '#c91b31';
      if(this.companyName.length >= 30 && this.companyName.length < 35){
        fontsize =  fontsize - 5;
      } else if(this.companyName.length >= 35 && this.companyName.length < 40){
        fontsize =  fontsize - 10;
      } else if(this.companyName.length >= 40 && this.companyName.length < 45){
        fontsize =  fontsize - 15;
      } else if (this.companyName.length >= 45 && this.companyName.length < 60){
        fontsize =  fontsize - 20;
      }  else if (this.companyName.length >= 60 && this.companyName.length < 80){
        fontsize =  fontsize - 25;
      } else if (this.companyName.length >= 80){
        fontsize =  fontsize - 28;
      } 
      ctx.font = fontsize + "px sans-serif";

      if (this.companyName.length > 95) {
        const lines: string[] = [];
        for (let i = 0; i < this.companyName.length; i += 95) {
          lines.push(this.companyName.slice(i, i + 95));
        }
      
        const offsetY = -25;
      
        lines.forEach((line, index) => {
          ctx.fillText(
            line,
            x,
            y / 2 + (index - Math.floor(lines.length / 2)) * fontsize + offsetY
          );
        });
      
      
      } else {
        var a = substrings.length;
        substrings.forEach((substrings, index) => {
          y = canvas.height;
          ctx.fillText(substrings, x, y + (index - a) * fontsize + fontsize - 120);
        });
      }
    } else {
      this.companyName = ''
    }
  }
}
